import { Box, Text, Divider, Heading } from '@chakra-ui/react';
import React from 'react';

import { PageHeader } from 'packages/common-frontend/components/PageContainer';
import { RailzConnectContainer } from 'packages/financial-data/ui/railz/RailzConnectContainer';

export const AccountingIntegrationsContainer = (params: {
  organizationId: string;
}) => {
  return (
    <Box id="accounting-integrations-container">
      <PageHeader headerLabel="Connect your accounting system" />
      <Text width="100%" mt="10px" fontSize="sm" align="left">
        Accounting systems are important financial data sources for debt capital
        compliance and monitoring.
      </Text>

      <Divider my="6" />

      <Box>
        <Heading as="h4" size="md" textAlign="left" mb="5">
          Railz Connections
        </Heading>
        <RailzConnectContainer organizationId={params.organizationId} />
      </Box>
    </Box>
  );
};
